import { create } from 'zustand'

import { initialAnimateSettingsState } from './slices/animateSettings'
import { initialCommunityGalleryFiltersState } from './slices/communityGalleryFilters'
import { initialDccBridgeState } from './slices/dccBridge'
import { initialExportState } from './slices/export'
import { initialFiltersState } from './slices/filters'
import { initialGenerationState } from './slices/generation'
import { initialImageSettingsState } from './slices/imageSettings'
import { initialModelSettingsState } from './slices/modelSettings'
import { initialNotificationPreferencesState } from './slices/notificationPreferences'
import { initialRemeshSettingsState } from './slices/remeshSettings'
import { initialRenderSettingsState } from './slices/renderSettings'
import { initialSchemaState } from './slices/schema'
import { initialSegmentSettingsState } from './slices/segmentSettings'
import { initialStaticViewerState } from './slices/staticViewer'
import { initialSubscriptionState } from './slices/subscription'
import { initialTextureSettingsState } from './slices/textureSettings'
import { initialUiState } from './slices/ui'
import { initialViewerState } from './slices/viewer'

const initialState = {
  ...initialAnimateSettingsState,
  ...initialCommunityGalleryFiltersState,
  ...initialDccBridgeState,
  ...initialExportState,
  ...initialFiltersState,
  ...initialGenerationState,
  ...initialImageSettingsState,
  ...initialModelSettingsState,
  ...initialNotificationPreferencesState,
  ...initialRemeshSettingsState,
  ...initialRenderSettingsState,
  ...initialSubscriptionState,
  ...initialTextureSettingsState,
  ...initialSchemaState,
  ...initialSegmentSettingsState,
  ...initialStaticViewerState,
  ...initialUiState,
  ...initialViewerState,
}

export const useThreeDStudioStore = create(() => initialState)

export const threeDStudioStore = useThreeDStudioStore
